import { render, staticRenderFns } from "./loan_pc.vue?vue&type=template&id=b6d243b0&scoped=true"
import script from "./loan_pc.vue?vue&type=script&lang=js"
export * from "./loan_pc.vue?vue&type=script&lang=js"
import style0 from "./loan_pc.vue?vue&type=style&index=0&id=b6d243b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d243b0",
  null
  
)

export default component.exports